<template>
  <span>
    <v-hover v-slot="{ hover }">
      <v-carousel
        v-model="model"
        cycle
        :interval="interval"
        :show-arrows="hover"
        hide-delimiters
        :height="height"
      >
        <v-carousel-item
          v-for="image in slideshow"
          :key="image.id"
          contain
          :src="'https://i.troplo.com/i/' + image.attachment"
        >
          <v-sheet tile>
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
            <v-chip
              v-if="hover"
              elevation="2"
              fab
              icon
              color="#2196F3"
              style="
                float: bottom;
                position: absolute;
                bottom: 20px;
                color: white;
              "
              class="elevation-10 slide-fab"
              @click="copy(image.attachment)"
              ><v-icon>mdi-content-copy</v-icon></v-chip
            >
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </v-hover>
  </span>
</template>

<script>
export default {
  name: "Slideshow",
  data() {
    return {
      slideshow: [],
      config: {},
      model: 0
    }
  },
  watch: {
    model() {
      if (this.model === this.slideshow.length - 3) {
        this.getSlideshow()
      }
    }
  },
  computed: {
    interval() {
      return this.config.speed * 1000
    },
    height() {
      return this.$vuetify.breakpoint.height
    }
  },
  methods: {
    copy(text) {
      navigator.clipboard.writeText("https://i.troplo.com/i/" + text)
    },
    getSlideshow() {
      this.axios
        .get("/api/v1/slideshow/" + this.$route.params.code)
        .then((res) => {
          this.slideshow = res.data
        })
    },
    getSlideshowConfig() {
      this.axios
        .get("/api/v1/slideshow/" + this.$route.params.code + "/config")
        .then((res) => {
          this.config = res.data
        })
    }
  },
  mounted() {
    this.getSlideshow()
    this.getSlideshowConfig()
  }
}
</script>

<style>
:root {
  background-color: transparent !important;
  overflow: hidden;
}
.v-window__next {
  float: right !important;
  position: absolute;
  right: 1px;
}
.img {
  max-width: 100% !important;
}
</style>
